class Product {
	constructor(
		id,
		type,
		amount,
		sellingPrice,
		initialSellingPrice,
		originalPurchasingPrice,
		purchasingPrice
	) {
		this.id = id;
		this.type = type;
		this.amount = amount;
		this.sellingPrice = sellingPrice;
		this.initialSellingPrice = initialSellingPrice;
		this.originalPurchasingPrice = originalPurchasingPrice;
		this.purchasingPrice = purchasingPrice;
	}

	toPlainObj() {
		return {
			id: this.id,
			type: this.type,
			amount: this.amount,
			sellingPrice: this.sellingPrice,
			initialSellingPrice: this.initialSellingPrice,
			originalPurchasingPrice: this.originalPurchasingPrice,
			purchasingPrice: this.purchasingPrice
		};
	}
}

export default function ProductBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withType: function (type) {
			this.type = type;
			return this;
		},
		withAmount: function (amount) {
			this.amount = amount;
			return this;
		},
		withSellingPrice: function (sellingPrice) {
			this.sellingPrice = parseInt(sellingPrice);
			return this;
		},
		withInitialSellingPrice: function (initialSellingPrice) {
			this.initialSellingPrice = parseInt(initialSellingPrice);
			return this;
		},
		withOriginalPurchasingPrice: function (originalPurchasingPrice) {
			this.originalPurchasingPrice = parseInt(originalPurchasingPrice);
			return this;
		},
		withPurchasingPrice: function (purchasingPrice) {
			this.purchasingPrice = parseInt(purchasingPrice);
			return this;
		},
		build: function () {
			return new Product(
				this.id,
				this.type,
				this.amount,
				this.sellingPrice,
				this.initialSellingPrice,
				this.originalPurchasingPrice,
				this.purchasingPrice
			);
		}
	};
}
